import React from "react";
import { Typography } from "@mui/material";

function Footer() {
  const ReportAutomator110 = "/resources/static/reportautomator/img/report-automator-gris.png";

  return (
    <div className="container-xxl mt-auto">
      <footer className="py-3">
        <div className="menu-image-logo d-flex justify-content-center mt-4 mb-2">
          <img src={ReportAutomator110} alt="report-automator-110"/>
        </div>
        <div className="pt-2 d-grid text-center">
          <Typography variant="caption">
            <a href="https://reportautomator.com/" className="link-opacity-50-hover text-decoration-none">Report Automator by Kiwox</a>
          </Typography>
          <Typography className="text-secondary" variant="caption">
            Algunos derechos reservados
          </Typography>
        </div>
        {process.env.REACT_APP_TEST_ENV && process.env.REACT_APP_VERSION}
      </footer>
    </div>
  );
}

export default Footer;
